angular.module('iqxCore')
  .controller('StaffologyPayslipsCtrl', function ($scope, FormSvc, $window, ApiSvc) {
    var fetchingPayslip = false

    moment.locale('en_gb', {
      week: {
        dow: 1 // Monday is the first day of the week
      }
    })

    $scope.checkPermissions('CANDIDATE')

    FormSvc.setOptions($scope, {
      fetchAPI: 'callresult/NetCandidateStaffologyPayslips',
      fetchTarget: 'payslips',
      fetchWithPersonID: true,
      multiRow: true
    })

    $scope.fetch()
      .then(() => {
        $scope.payslips.forEach((payslip, key) => {
          $scope.payslips[key]['JSONContent'] = JSON.parse($scope.payslips[key]['JSONContent'])
          $scope.payslips[key]['date'] = moment($scope.payslips[key]['JSONContent']['to']).format("D/MM/YY")
        })

      })

    $scope.viewPaySlip = function (payslip) {
      if (fetchingPayslip){ return }
      fetchingPayslip = true
      return ApiSvc.exec($scope, 'pdf-payslip/payslip', { payslip: payslip["JSONContent"] })
        .then(function (res) {
          fetchingPayslip = false
          var pdfBuffer = res.IQXResult.data.payslip.data
          var tempFile = new Blob([new Uint8Array(pdfBuffer).buffer], { name: 'payslip.pdf', type: 'application/pdf' });

          var tempFileURL = URL.createObjectURL(tempFile)
          $window.open(tempFileURL, '_blank')
        })
    }

  })